<!-- !连续型电子出版物 -->

<template>
  <div class="press-8">
    <div class="rejects" v-if="opMsg">
      <div class="rejLine">
        <div class="rejName">状态：</div>
        <div class="rejText" v-if="msgStatus == 21">暂缓登记</div>
        <div class="rejText" v-if="msgStatus == 3">退回</div>
      </div>
      <div class="rejLine">
        <div class="rejName">原因：</div>
        <div class="rejText">{{ opMsg }}</div>
      </div>
    </div>

    <div class="headBar">
      <span>{{ querys.bookName }}</span>
      <!-- <el-button size="mini" @click="copyHandle('show')">数据拷贝</el-button> -->
    </div>

    <div class="tabArea">
      <table class="tabElement">
        <tr class="tabHead">
          <td>序号</td>
          <td>连续型电子出版物出版情况登记表</td>

          <td>更新时间</td>
          <td colspan="2">操作</td>
        </tr>
        <tr :key="inx" v-for="(term, inx) in tabDat">
          <td>{{ inx + 1 }}</td>
          <td>{{ term.name }}</td>
          <td>{{ term | translate("time") }}</td>
          <td style="width: 150px">
            <span v-if="term.code != 501">
              <el-button v-if="!modifyFlag" @click="toEdit(term, 2)" type="primary" size="mini">查看</el-button>
              <el-button v-if="modifyFlag && term.status == 1" @click="toEdit(term, 1)" type="primary" size="mini"
                >填表</el-button
              >
              <el-button v-if="modifyFlag && term.status != 1" @click="toEdit(term, 2)" type="danger" size="mini"
                >修改</el-button
              >
            </span>
            <span v-if="term.code == 501">
              <UpBtn
                v-if="pubStatus == 1 || pubStatus == 0"
                :fileID="zeroStoreage[term.id] ? zeroStoreage[term.id].fileId : ''"
                :btnProps="{ ...term }"
                @zeroTabStore="zeroStoreCtrls"
                :pubStatus="
                  (term.name == '整改报告' && pubStatus == 0 && isModifyStage == '1') ||
                  (term.name != '整改报告' && pubStatus == 0)
                    ? 0
                    : 1
                " />
            </span>
          </td>
          <td style="width: 120px" v-if="inx == 0" rowspan="3">
            <a href="javascript:void(0);" @click="dmyfile(1)">
              <el-button size="mini">导出打印表</el-button>
            </a>
          </td>
          <td style="width: 120px" v-if="term.code == '501'" rowspan="3">&nbsp;</td>
          <!-- <td style="width: 120px" v-else-if="inx == 3">
            <a href="javascript:void(0);" @click="dmyfile(2)">
              <el-button size="mini">导出打印表</el-button>
            </a>
          </td> -->
          <!-- <td style="width: 120px" v-else-if="inx == 2"></td> -->
        </tr>
        <!-- <tr >
            <td>5</td>
            <td>出版经营情况调查表</td>
            <td></td>
            <td>
              <el-button
                @click="toEdit({code:405},2)" type="danger" size="mini">修改</el-button>
            </td>
            <td>
                &nbsp;
            </td>
        </tr> -->
      </table>
      <!-- <el-table :data="tabDat" border style="width: 100%">
                <el-table-column label="序号" width="60" align="center" type="index">
                </el-table-column>
                <el-table-column prop="name" label="连续型电子出版物登记情况表" align="center"></el-table-column>
                <el-table-column label="完成进度" align="center">
                     <template slot-scope="scope">
                     	  {{ scope.row.status | translate('pgress') }}
                     </template>
                </el-table-column>
                <el-table-column label="更新时间" align="center">
                     <template slot-scope="scope">
                     	  {{ scope.row | translate('time') }}
                     </template>
                </el-table-column>
                <el-table-column label="操作" width="200" align="center">
                     <template slot-scope="scope">
                           <el-button v-if="scope.row.status == 1" @click="toEdit(scope.row,1)" type="primary" size="mini">填表</el-button>
                           <el-button v-else @click="toEdit(scope.row,2)" type="danger" size="mini">修改</el-button>
                     </template>
                </el-table-column>
             </el-table> -->
      <div class="tabTips">注：上传整改报告文件格式为WORD，文件大小不超过100M</div>
    </div>

    <div class="subArea">
      <el-button @click="goBack" size="small">返回</el-button>
    </div>

    <el-dialog
      class="ssPressDiag"
      title="选择需要拷贝的表"
      :visible.sync="dialogVisible"
      width="450px"
      @close="handleClose">
      <div v-if="checkList.length > 0">
        <div class="tips">
          数据拷贝会覆盖现有已填写的数据，请谨慎操作！复制的内容如有微调不同，请点击“编辑”按钮进入修改。
        </div>
        <el-checkbox-group v-model="codeArr">
          <div v-for="(tab, index) in checkList" class="selectItem">
            <el-checkbox :label="tab.materialCode" :key="tab.id"
              >{{ tab.materialCode.substr(2, 3) }} {{ tab.materialTitle }}</el-checkbox
            >
          </div>
        </el-checkbox-group>
      </div>
      <div class="errors" v-else>目前尚未生成可拷贝的表</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button v-if="checkList.length > 0" type="primary" @click="copyHandle('act')" size="small">拷 贝</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import UpBtn from "@/views/components/uploadBtn";
import { sUpdate0 } from "@/api/pressRole/pressRole";
import {
  getSuccessTabs,
  ssCopyList,
  ssCopyAct,
  getLxdzModifyFlagByOMaterial, // zym.判断是否可以修改数据 - 资料清单列表页面
} from "@/api/pressRole/pressSuccessive";
import { expFile } from "@/api/export";
export default {
  props: ["pressType"],
  components: {
    UpBtn,
  },
  data() {
    return {
      querys: {
        listId: "",
        bookName: "",
      },
      tabDat: [],
      zeroStoreage: {
        id: "",
        publishMaterialId: "",
        publishId: "",
        fileId: "",

        wSat: 0,
      },
      opMsg: "",

      // 数据拷贝
      dialogVisible: false,
      checkList: [],
      codeArr: [],

      // zym.文件上传信息存储（改造成数组）
      zeroStoreage: {},
      pubStatus: 0,
      // 核验状态
      msgStatus: "",
    };
  },
  filters: {
    translate: function (dat, code) {
      if (code == "pgress") {
        if (dat == 1) {
          return "未提交";
        } else if (dat == 2) {
          return "已提交";
        }
      } else if (code == "time") {
        if (dat.status == 2) {
          return dat.updatedAt.substr(0, 10);
        } else {
          return "/";
        }
      }
    },
  },
  methods: {
    // zym.他是通用的，感觉this.zeroStoreage使用有问题，因为这个地方有两个文件
    // zym.上传完成后，更新文件上传的信息
    // zym.dat = 上传之后，返回来的fileId
    zeroStoreCtrls: function (dat, btnProps) {
      console.log("dat=", dat);
      console.log("btnProps=", JSON.stringify(btnProps));

      let btnKey = btnProps.id;
      // 材料类型名称
      let materialTitle = btnProps.name;

      let detAble, idOld, publishMaterialId;
      if (this.zeroStoreage[btnKey]) {
        detAble = this.zeroStoreage[btnKey].fileId;
        idOld = this.zeroStoreage[btnKey].id;
        publishMaterialId = this.zeroStoreage[btnKey].publishMaterialId;
      }

      let vm = this;
      this.zeroStoreage[btnKey].fileId = dat;
      sUpdate0({
        id: idOld,
        publishMaterialId: publishMaterialId,
        fileId: dat,
        materialTitle: materialTitle, // zym.新增
        code: 501,
        // pfile1: this.zeroStoreage
      })
        .then((response) => {
          console.log("sUpdate0 file = ", JSON.stringify(response));
          let code = response.payload.tipCode;
          let msg = response.payload.message;
          if (code != "success") {
          }
          // zym.成功，需要刷新页面
          else {
            vm.$emit("go-frash");
          }
        })
        .catch((error) => {});
    },
    handleClose: function () {},
    toEdit: function (row, type) {
      let urlMap = {
        401: "edit_ssTab1", // pressRole/SuccessivePart/forEdit/ssTab1
        402: "edit_ssTab2", // pressRole/SuccessivePart/forEdit/ssTab2
        403: "edit_ssTab3", // pressRole/SuccessivePart/forEdit/ssTab3
        404: "sstab4_list", // pressRole/SuccessivePart/forTabs/ssTab4

        405: "edit_ssTab5", // pressRole/SuccessivePart/forTabs/ssTab4
      };
      this.$router.push({
        path: urlMap[row.code],
        query: {
          pressId: row.organizationId,
          mtId: row.id,
          pgress: type,

          listId: this.$route.query.listId, // zym.publishMaterialId

          bookName: this.querys.bookName,
          mtcode: this.$route.query.mtcode, // zym.materialCode 出版物的code编号
        },
      });
    },

    copyHandle: function (code) {
      let vm = this;
      if (code == "show") {
        this.dialogVisible = true;
        ssCopyList().then((response) => {
          vm.checkList = response.synchroCodeList;
        });
      } else if (code == "act") {
        ssCopyAct({
          publishMaterialId: this.$route.query.listId,
          codes: vm.codeArr,
        }).then((response) => {
          this.$message.success("拷贝成功");
          this.dialogVisible = false;
          this.$emit("go-frash");
        });
      }
    },

    pressInit: function () {
      let vm = this;
      getSuccessTabs({
        publishMaterialId: this.$route.query.listId,
        no: 1,
        size: 15,
      }).then((response) => {
        let tabDat = response.ppublicationOrganizationMaterialList;

        // zym.20250606，复制音电逻辑。是否出版社阶段，后天比对的是progress（CONST.TASKTYPE.START.value），如果是出版社阶段返回0，否则返回1
        this.pubStatus = response.pubStatus;

        let zgbgPublishMaterialId = undefined;
        let publishId = undefined;
        let filterList = (tabDat || []).filter((item) => {
          // 如果是整改报告
          if (item.code == "501") {
            zgbgPublishMaterialId = item.id;
            publishId = item.organizationId;
          }
          return item.code != "402" && item.code != "404";
        });
        this.tabDat = filterList;
        this.opMsg = response.opMsg;
        // 状态
        this.msgStatus = response.msgStatus;

        this.modifyFlag = response.modifyFlag;
        this.modifyFlag = response.modifyFlag;
        // zym.20250609，新增逻辑
        this.isModifyStage = response.isModifyStage;

        // zym.因为整改报告、自查报告都是 code=101，所以根据材料名称做个判断
        let fileId = undefined;
        if (response.zgbgFile && response.zgbgFile.id) {
          fileId = response.zgbgFile.id;
        }

        // 设置文件上传信息
        console.log("zgbgPublishMaterialId=", zgbgPublishMaterialId);
        console.log("publishId=", publishId);
        this.zeroStoreage[zgbgPublishMaterialId] = {
          publishMaterialId: zgbgPublishMaterialId,
          publishId,
          fileId,
        };
        console.log("this.zeroStoreage=", this.zeroStoreage);

        vm.printUrl =
          process.env.BASE_API +
          "/File/File/printLxJbxx?type=" +
          vm.pressType +
          "&publishMaterialId=" +
          vm.querys.listId +
          "&token=" +
          encodeURIComponent(vm.$store.getters.token);
        vm.printUrl1 =
          process.env.BASE_API +
          "/File/File/printRyJbxx?type=3&publishMaterialId=" +
          vm.tabDat[3].id +
          "&token=" +
          encodeURIComponent(vm.$store.getters.token);
      });
    },
    dmyfile: function (exp) {
      var params = {};
      var expUrl = "";
      if (exp == 1) {
        expUrl = "/api/export/printLxJbxx";
        params = {
          firstYear: this.$route.query.firstYear,
          type: this.pressType,
          publishMaterialId: this.querys.listId,
        };
      } else if (exp == 2) {
        expUrl = "/api/export/printRyJbxx";
        params = {
          type: 3,
          publishMaterialId: this.tabDat[3].id,
        };
      }
      expFile({ expUrl: expUrl, p: params })
        .then((blob) => {
          let blobHref = window.URL.createObjectURL(blob);
          let anchor = document.createElement("a");
          anchor.href = blobHref;
          var fname = localStorage.getItem("dfilename");
          anchor.download = decodeURIComponent(fname);
          document.body.appendChild(anchor);
          anchor.click();
          window.URL.revokeObjectURL(blobHref);
          document.body.removeChild(anchor);
        })
        .catch((error) => {});
    },
    goBack: function () {
      this.$router.push({
        path: "successive_press",
      });
    },
    // zym.判断是否可以修改
    getLxdzModifyFlagByOMaterial: function () {
      console.log("getLxdzModifyFlagByOMaterial...");
      let vm = this;
      getLxdzModifyFlagByOMaterial({
        publishMaterialId: this.$route.query.listId, // *publicationOrganizationMaterial的主键
      }).then((response) => {
        vm.modifyFlag = response.payload;
      });
    },
  },
  created: function () {
    // this.getLxdzModifyFlagByOMaterial();

    this.pressInit();
    this.querys.listId = this.$route.query.listId;
    this.querys.bookName = this.$route.query.bookName;
  },
};
</script>

<style lang="scss" scoped>
.press-8 {
  padding: 9px;
  font-size: 14px;
  letter-spacing: 0.72px;

  .rejects {
    border: 1px solid red;
    color: red;
    padding: 15px 0px;
    border-radius: 3px;
    margin-bottom: 9px;

    .rejLine {
      position: relative;
      line-height: 20px;

      .rejName {
        width: 70px;
        text-align: right;
        float: left;
      }

      .rejText {
        margin-left: 65px;
      }
    }
  }

  .headBar {
    padding: 0px 24px;
    height: 45px;
    line-height: 45px;
    background: #f8f8f8;
    color: #666666;

    .el-button {
      float: right;
      margin-top: 9px;
      width: 90px;
    }
  }

  .tabArea {
    margin-top: 12px;
    padding-bottom: 24px;
    .tabTips {
      font-size: 14px;
      color: #464646;
      margin-top: 9px;
      line-height: 1.5em;

      .tipBold {
        font-weight: bold;
      }
      .tipLine {
        padding-left: 20px;
        position: relative;

        .fsDot {
          width: 45px;
          position: absolute;
          left: 0;
        }
      }
    }

    .tabElement {
      width: 100%;

      .tabHead {
        font-size: 14px;
        font-weight: bold;

        td {
          // background: #f5f7fa;
          padding: 15px 20px;
          color: #909399;
        }
      }

      td {
        border-collapse: collapse;
        border: 1px solid #ebeef5;
        text-align: center;
        padding: 12px;
        color: #606266;
      }
    }
  }

  .tabTips {
    font-size: 12px;
    color: #999999;
    margin-top: 9px;

    .tipLine {
      padding-left: 20px;
      position: relative;

      .fsDot {
        width: 45px;
        position: absolute;
        left: 0px;
      }
    }
  }

  .subBar {
    padding: 0px 24px;
    height: 45px;
    line-height: 45px;
    background: #f8f8f8;
    margin-top: 6px;
    color: #666666;
  }

  .subArea {
    text-align: center;
    margin-top: 30px;
    margin-bottom: 50px;

    .el-button {
      width: 150px;
    }
  }

  .succedTips {
    font-size: 14px;
    color: #666666;
    padding: 20px;

    a {
      color: #409eff;
    }
  }

  .dvsWait {
    text-align: center;
    line-height: 240px;
    font-size: 24px;
    color: #999999;
  }
}
</style>

<style>
.ssPressDiag .el-dialog__body {
  padding: 6px 30px !important;
}

.ssPressDiag .tips {
  padding-left: 6px;
  margin-bottom: 12px;
  font-size: 12px;
  color: salmon;
}

.ssPressDiag .errors {
  font-size: 15px;
  color: #999999;
  padding-top: 6px;
}
</style>



// WEBPACK FOOTER //
// successiveTabs.vue?6ddf840e